function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "28",
  viewBox: "0 0 202 192",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.083 109.284a9.767 9.767 0 014.896-8.462l37.224-21.448c6.53-3.763 14.695.939 14.695 8.462v36.517a9.774 9.774 0 01-6.82 9.31l-37.223 11.845c-6.32 2.011-12.772-2.693-12.772-9.31v-26.914z",
  fill: "#44A5FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.594 87.612a9.762 9.762 0 013.415-7.415l90.61-77.605a9.814 9.814 0 0112.762 0l90.61 77.605a9.761 9.761 0 013.415 7.415v94.209c0 5.397-4.385 9.772-9.795 9.772H63.835c-11.194 0-13.633-15.708-2.964-19.086l76.398-24.191a9.774 9.774 0 006.832-9.315v-23.632a9.76 9.76 0 00-3.298-7.312l-33.462-29.59a9.815 9.815 0 00-12.816-.155l-77.818 65.513c-6.369 5.362-16.113.845-16.113-7.468V87.612z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: ".594",
  y1: "117.325",
  x2: "201.406",
  y2: "117.325",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4462FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#44A5FF"
}))));